import {
  List,
  Datagrid,
  TextField,
  NumberField,
  Edit,
  SimpleForm,
  NumberInput,
  Show,
  SimpleShowLayout,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  ArrayField,
  ChipField,
  SelectInput,
  ReferenceField,
} from 'react-admin'

import { RECCOMENDATION_TYPE_OPTIONS } from '../config/constants'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const BotConfigList = ({ isEdit }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <TextField source="title" />
      <NumberField source="intervalInMinutes" />
      <NumberField source="tokensLimit" />
      <NumberField source="temperature" />
      <NumberField source="maxOutputTokens" />
      <ReferenceField source="updatedBy" reference="users" />
    </Datagrid>
  </List>
)

export const BotConfigEdit = () => (
  <Edit>
    <SimpleForm>
      <NumberInput source="intervalInMinutes" />
      <NumberInput source="tokensLimit" />
      <NumberInput source="temperature" />
      <NumberInput source="maxOutputTokens" />
      <TextInput source="instructions" fullWidth multiline />
      <ArrayInput source='prompts'>
        <SimpleFormIterator fullWidth>
          <SelectInput
            source="recommendationType"
            choices={RECCOMENDATION_TYPE_OPTIONS}
          />
          <TextInput source='text' fullWidth multiline />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
)

export const BotConfigShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <NumberField source="intervalInMinutes" />
      <NumberField source="tokensLimit" />
      <NumberField source="temperature" />
      <NumberField source="maxOutputTokens" />
      <TextField source="instructions" />
      <ArrayField source="prompts">
        <Datagrid>
          <ChipField source="recommendationType" />
          <TextField source="text" />
        </Datagrid>
      </ArrayField>
    <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
